import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InterswitchTransactions from "../components/interswitch_transactions/InterswitchTransactions";
import BankTransfers from "../components/bank_transfers/BankTransfers";

const Transactions = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const activeTab = searchParams.get("tab") || "interswitch";

  const handleTabSwitch = (tab: string) => {
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set("tab", tab);
    navigate(`${location.pathname}?${newSearchParams.toString()}`);
  };

  const tabs = [
    { id: "interswitch", label: "Interswitch Transactions" },
    { id: "bank-transfers", label: "Bank Transfers" },
  ];

  return (
    <section className="p-4 md:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <p className="text-gray-600">
            View Interswitch Transactions and See Bank transfers.
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="flex space-x-8 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabSwitch(tab.id)}
                className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                  activeTab === tab.id
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 md:p-8">
          {activeTab === "interswitch" && <InterswitchTransactions />}

          {activeTab === "bank-transfers" && <BankTransfers />}
        </div>
      </div>
    </section>
  );
};

export default Transactions;
